module.exports = __webpack_public_path__ + "img/moon-eclipse.9fadd782.svg";